import { createSlice } from "@reduxjs/toolkit";
import {cookiesExpire, cookiesGet, cookiesSet} from "redux-cookies";
import axios from "axios";

const AXIOS_BASE_URL = '/rest';

const userSlice = createSlice({
    name: 'user',
    initialState: { loggedIn: false, user: null },
    reducers: {
        initUser: (state, action) => {
            return {
                ...state,
                loggedIn: true,
                user: action.payload.user
            }
        },
        clearUser: (state, action) => {
            return {
                ...state,
                loggedIn: false,
                user: null
            }
        }
    }
});

function initAxios(baseUrl, authorization) {
    axios.defaults.baseURL = baseUrl;
    if(typeof authorization !== "undefined") {
        axios.defaults.headers.common['Authorization'] = authorization;
    }
}

function saveCredentials(dispatch, userId, token, level) {
    let globals = {
        userId: userId,
        authorization: userId + ":" + token,
        level: level
    };

    let now = new Date(), exp = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());
    let domain = window.location.host.startsWith("www") ? window.location.host.slice(3) : window.location.host;
    let options = {
        expires: exp,
        sameSite: false,
        path: '/',
        domain: domain
    };
    dispatch(cookiesSet("globals_bubbly", JSON.stringify(globals), options));
    initAxios( AXIOS_BASE_URL,  globals.authorization);
    dispatch(initUser({ user: globals }));
}

export const clearCredentials = () => (dispatch) => {
    let domain = window.location.host.startsWith("www") ? window.location.host.slice(3) : window.location.host;
    let options = {
        sameSite: false,
        path: '/',
        domain: domain
    };
    dispatch(cookiesExpire("globals_bubbly", options));
    dispatch(clearUser());
};

export const restoreSession = () => (dispatch) => {
    const globals = dispatch(cookiesGet("globals_bubbly"));
    if (typeof globals !== "undefined") {
        const jsonGlobals = JSON.parse(globals);
        initAxios(AXIOS_BASE_URL, jsonGlobals.authorization);
        dispatch(initUser({user: jsonGlobals}));
    } else {
        initAxios(AXIOS_BASE_URL);
    }
};

export const saveUserActivationData = (userId, token, level) => (dispatch) => {
    saveCredentials(dispatch,userId,token,level);
};

export const { initUser, clearUser } = userSlice.actions;
export default userSlice.reducer;